import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'logo',
      component: () => import(/* webpackChunkName: "logo" */ './views/LogoPage.vue')
    },
    {
      path: '/slides',
      name: 'slides',
      component: () => import(/* webpackChunkName: "slides" */ './views/SlidesPage.vue')
    },
    {
      path: '/menu',
      name: 'menu',
      component: () => import(/* webpackChunkName: "menu" */ './views/Menu/MenuPage.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */ './views/Menu/HomePage.vue')
        },
        {
          path: '/myTimetables',
          name: 'myTimetables',
          component: () => import(/* webpackChunkName: "myTimetables" */ './views/Menu/MyTimetablesPage.vue')
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "settings" */ './views/Menu/SettingsPage.vue')
        }
      ]
    },
  ]
})
